import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { CrowdFlowObserved } from '../../model/crowd-flow-observed';

export interface CrowdFlowObservedState extends EntityState<CrowdFlowObserved> { }

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'CrowdFlowObserved' })
export class CrowdFlowsObservedStore extends EntityStore<CrowdFlowObservedState> {

  constructor() {
    super();
  }

}

